export default __webpack_public_path__ + "static/media/meetrix_logo dark.48887216.png";